import EmailIcon from "@mui/icons-material/Email";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import { Box, Card, Stack, Typography } from "@mui/material";
import React from "react";

const contactData = [
  {
    icon: <PhoneIcon sx={{ width: 100, height: 100, color: "white" }} />,
    backgroundColor: "success.main",
    title: "We are just a call away",
    info: "+923210111707",
  },
  {
    icon: <EmailIcon sx={{ width: 100, height: 100, color: "white" }} />,
    backgroundColor: "warning.main",
    title: "Get in touch with us online",
    info: "umar.shakeel@apna-card.com",
  },
  {
    icon: <LocationOnIcon sx={{ width: 100, height: 100, color: "white" }} />,
    backgroundColor: "error.main",
    title: "275 Y-Block, DHA Phase III, Lahore 54000, Pakistan.",
    singleLine: true,
  },
];

const GetInTouchSection = () => {
  return (
    <Box
      component="section"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: { xs: 4, md: 6 },
        px: { xs: 2.5, sm: 4, md: "100px" },
        py: { xs: 5, md: "50px" },
        bgcolor: "primary.main",
      }}
    >
      <Typography
        variant="h2"
        color="secondary.main"
        align="center"
        sx={{
          width: "100%",
          fontFamily: "Jost-Bold, Montserrat",
          fontWeight: 700,
          fontSize: { xs: 36, sm: 42, md: 64 },
        }}
      >
        GET IN TOUCH
      </Typography>

      <Stack
        direction={{ xs: "column", md: "row" }}
        justifyContent="space-between"
        alignItems="center"
        width="100%"
        gap={{ xs: 4, md: 3 }}
      >
        {contactData.map((item, index) => (
          <Box
            key={index}
            sx={{
              width: { xs: "100%", sm: "80%", md: 304 },
              maxWidth: { xs: 360, md: 304 },
            }}
          >
            <Card
              sx={{
                width: "100%",
                height: { xs: 140, sm: 150 },
                bgcolor: item.backgroundColor,
                borderRadius: "20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mb: 2,
              }}
            >
              {React.cloneElement(item.icon, {
                sx: {
                  width: { xs: 64, sm: 80, md: 100 },
                  height: { xs: 64, sm: 80, md: 100 },
                  color: "white",
                },
              })}
            </Card>

            <Typography
              color="secondary.main"
              fontSize={{ xs: 16, sm: 18, md: 20 }}
              align="center"
              sx={{
                width: "100%",
                minHeight: item.singleLine ? 60 : 30,
                fontFamily: "Poppins-Regular, Montserrat",
                letterSpacing: "-0.32px",
                lineHeight: 1.5,
              }}
            >
              {item.title}
            </Typography>

            {!item.singleLine && (
              <Typography
                color="secondary.main"
                fontSize={{ xs: 16, sm: 18, md: 20 }}
                align="center"
                sx={{
                  width: "100%",
                  height: 30,
                  fontFamily: "Poppins-Regular, Montserrat",
                  letterSpacing: "-0.32px",
                  lineHeight: 1.5,
                }}
              >
                {item.info}
              </Typography>
            )}
          </Box>
        ))}
      </Stack>
    </Box>
  );
};

export default GetInTouchSection;
